var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageArrowRightOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0158 4.89998C7.41659 4.89998 3.93162 8.07203 3.93162 11.7068C3.93162 13.0128 4.36923 14.2386 5.14169 15.2779C5.25704 15.4332 5.31934 15.6214 5.31934 15.8148C5.31934 16.7146 5.08289 17.5852 4.79359 18.3677C4.62079 18.8351 4.41703 19.3005 4.22038 19.7354C5.93378 19.5412 7.05532 18.9847 7.73306 18.1879C7.97889 17.8989 8.37957 17.795 8.73482 17.9283C9.73479 18.3036 10.8443 18.5136 12.0158 18.5136C16.6151 18.5136 20.1 15.3415 20.1 11.7068C20.1 8.07203 16.6151 4.89998 12.0158 4.89998ZM3.85231 20.546L3.85378 20.5427L3.85231 20.546ZM2.13162 11.7068C2.13162 6.82881 6.69139 3.09998 12.0158 3.09998C17.3403 3.09998 21.9 6.82881 21.9 11.7068C21.9 16.5847 17.3403 20.3136 12.0158 20.3136C10.8433 20.3136 9.71581 20.1358 8.66833 19.8081C7.42025 20.9611 5.61596 21.5128 3.4202 21.599C2.49327 21.6354 1.82177 20.6717 2.21117 19.8066C2.28839 19.6338 2.36618 19.4633 2.44343 19.294C2.67958 18.7764 2.91068 18.2698 3.10529 17.7435C3.32197 17.1574 3.46921 16.6059 3.5087 16.0878C2.63785 14.8156 2.13162 13.3152 2.13162 11.7068Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60005 11.5C7.60005 11.0029 8.00299 10.6 8.50005 10.6H15.5C15.9971 10.6 16.4 11.0029 16.4 11.5C16.4 11.997 15.9971 12.4 15.5 12.4H8.50005C8.00299 12.4 7.60005 11.997 7.60005 11.5Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2637 8.26358C12.6151 7.91211 13.185 7.91211 13.5364 8.26358L16.1364 10.8636C16.4879 11.215 16.4879 11.7849 16.1365 12.1364L13.5366 14.7363C13.1851 15.0878 12.6152 15.0878 12.2638 14.7364C11.9123 14.3849 11.9123 13.815 12.2637 13.4636L14.2273 11.5L12.2637 9.53637C11.9122 9.1849 11.9122 8.61505 12.2637 8.26358Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageArrowRightOutline);
export default __webpack_public_path__ + "static/media/message_arrow_right_outline.a09176698d0f6c779366bdb0a16d1b70.svg";
export { ForwardRef as ReactComponent };